import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import { PreloadScene } from './preload';
import store from './store';
import Default from './components/Default.vue';
import './icons';
import { syncFrameHeight, DPR, isDesktop, redirectLogin, isIOSLike} from "./helpers";
import lang from './filters/lang';
import currency from './filters/currency';
import closable from './directives/closable';
import socket from '@tv/socket';
import Axios from "axios";
import ContainerLitePlugin from 'phaser3-rex-plugins/plugins/containerlite-plugin.js';
import DragRotatePlugin from 'phaser3-rex-plugins/plugins/dragrotate-plugin.js'

Config.isDesktop = isDesktop();

parent.postMessage({ 'require_sizes':true }, '*');

Axios.defaults.headers.common['X-CSRF-TOKEN'] = Config.csrf_token;

moment.locale(Config.language);

Vue.filter('currency', currency);
Vue.filter('lang', lang);
Vue.directive('closable', closable);

let gameStarted = false;
let loadStarted = false;
let scene;

for (const item of ['symbols', 'assets', 'settings', 'odds']) {
    Config[item] = JSON.parse(atob(Config[item]));
}

Config.resolutionX = Config.settings.resolution && Config.settings.resolution.x ? Config.settings.resolution.x : 1920;
Config.resolutionY = Config.settings.resolution && Config.settings.resolution.y ? Config.settings.resolution.y : 1080;
Config.resolutionX_portrait = Config.settings.resolution && Config.settings.resolution.x_portrait ? Config.settings.resolution.x_portrait : 1080;
Config.resolutionY_portrait = Config.settings.resolution && Config.settings.resolution.y_portrait ? Config.settings.resolution.y_portrait : 1920;

let width = Config.resolutionX;
let height = Config.resolutionY;

if(!Config.isDesktop && Config.windowHeight > Config.windowWidth) {
    width = Config.resolutionX_portrait;
    height = Config.resolutionY_portrait;
}

if (!General.is_iframe()) {
    document.body.classList.add('iframe-no')
}

let mode = Config.settings.forceWebgl ? Phaser.WEBGL : Phaser.CANVAS;
mode = Config.settings.iOSForceCanvas && isIOSLike() ? Phaser.CANVAS : mode;

let config = {
    type: mode,
    //pixelArt: true,
    parent: 'fg-canvas',
    width: width,
    height: height,
    transparent: true,
    roundPixels: true,
    physics: {
        default: 'arcade'
    },
    scale: {
        mode: Phaser.Scale.WIDTH_CONTROLS_HEIGHT,
        zoom: 1 / DPR,
        width: width * DPR,
        height: height * DPR,
        autoCenter: Phaser.Scale.Center.CENTER_BOTH
    },
    dom: {
      createContainer: true,
    },
    fps: {
        target: 30,
    },
	plugins: {
        global: [{
            key: 'rexContainerLitePlugin',
            plugin: ContainerLitePlugin,
            start: true
        }]
	}
};

if (Config.settings.rexDragRotate) {
    config.plugins.global.push({
        key: 'rexDragRotate',
        plugin: DragRotatePlugin,
        start: true
    });
}

if (Config.settings.configParams) {
    config = { ...config, ...Config.settings.configParams };
}

const game = new Phaser.Game(config);

let neededWidth = document.body.offsetWidth;
let messageResizeGot = false;
let emergencyLoadTimer = false;

window.addEventListener('message', function(e) {
    if (!isResizeNeeded(e.data.viewportHeight, e.data.viewportWidth)) {
        return;
    }

    if (e.data.viewportWidth) {
        Config.windowWidth = e.data.viewportWidth;
    }
    
    if (e.data.viewportHeight) {
        Config.windowHeight = e.data.viewportHeight;
        
        messageResizeGot = true;
        
        if(!Config.isDesktop && Config.windowHeight > Config.windowWidth) { //todo check how to get orientation from scene
            neededWidth = Config.windowHeight * (1 / (Config.resolutionY_portrait / Config.resolutionX_portrait));
        } else {
            neededWidth = Config.windowHeight / (1 / (Config.resolutionX / Config.resolutionY));
        }

        if(window.innerWidth < neededWidth && (Config.windowWidth < neededWidth || Config.isDesktop)) {
            neededWidth = document.body.offsetWidth;

            if(!Config.isDesktop && Config.windowHeight > Config.windowWidth) { //todo check how to get orientation from scene
                Config.windowHeight = neededWidth / (1 / (Config.resolutionY_portrait / Config.resolutionX_portrait));
            } else {
                Config.windowHeight = neededWidth * (1 / (Config.resolutionX / Config.resolutionY));
            }
        }

        if(gameStarted) {
            syncFrameHeight(Config.windowHeight, neededWidth, game);
        }
    }
});

$(window).on('resize', () => {
    manualHeightSync();
});

if (!Config.full_integration) {
    setTimeout(() => {
        manualHeightSync();
    }, 0)
}

function manualHeightSync() {
    if(General.is_iframe() && !messageResizeGot) {
        return;
    }

    if(!messageResizeGot) {
        Config.windowHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        Config.windowWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

        neededWidth = Config.windowWidth;
    }

    syncFrameHeight(Config.windowHeight, neededWidth, game);

    setTimeout(() => {
        if(gameStarted) {
            syncFrameHeight(Config.windowHeight, neededWidth, game);
        }
    }, 500);
}

function isResizeNeeded(height, width) {
    var widthChangedBy = Math.abs(width - Config.resizeCheckWindowWidth);
    var heightChangedBy = Math.abs(height - Config.resizeCheckWindowHeight);

    if (Config.resizeCheckCount) {
        Config.resizeCheckCount--;
    }

    if (Config.resizeCheckCount) {
        return true;
    }

    if (height && (heightChangedBy > 10 || !Config.resizeCheckWindowHeight)) {
        Config.resizeCheckWindowHeight = height;
        Config.resizeCheckCount = 5;
        return true;
    }

    if (width && (widthChangedBy > 10 || !Config.resizeCheckWindowWidth)) {
        Config.resizeCheckWindowWidth = width;
        Config.resizeCheckCount = 5;
        return true;
    }

    return false;
}

Vue.use(BootstrapVue);


new Vue({
    el: '#fg-panel-holder',
    store,
    components: { Default },
});

socket.on('socket_token', res => {
    Config.token = res.token;
});

socket.on('transmission', (packet) =>
{
    log.debug('Received transmission', packet);

    if(packet.action == 'reload') {
        store.commit('setAfterMessage', () => location.reload());
        store.commit('setMessage', 
            {
                message:'socket_error',
                callback:location.reload()
            }
        );
    }

    if(packet.action == 'logout') {
        store.commit('setMessage', 
            {
                title: 'please_login',
                message:'in_order_to_buy',
                callback: {
                    title: 'ok',
                    callback:() => {
                        if (Config.login_page) {
                            redirectLogin();
                        } else {
                            parent.postMessage({ auth: true }, '*');
                            location.reload();
                        }
                    },
                }
            }
        );
    }
});

socket.on('lifetimeAmount', res => {
    if (res.currency == Config.currency_code) {
        store.commit('updateLifetimeAmount', res.amount);
    }
});

socket.on('balance', res => {
    store.commit('setBalance', res.amount)
});

socket.on('ticketPayout', e => {
    if (scene && !scene.request.setCompleteInProgress) {
        if (scene.request.ticketId == e.id && scene.request.ticketInProgress) {
            location.replace(Config.route.ticket_payout);
        }
    }
});

function loadFont(name, url, callback, callbackParam) {
    var newFont = new FontFace(name, `url(${url})`);

    newFont.load().then(function (loaded) {
        document.fonts.add(loaded);
        callback(callbackParam);
    }).catch(function (error) {
        console.log(error);
    });

    if(name === 'Artifakt') {
        emergencyLoadTimer = setTimeout(() => {
            clearTimeout(emergencyLoadTimer);
            callback(callbackParam);
        }, 5000);
    }
}

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

function awaitSizes(fn) {
    if (messageResizeGot || !General.is_iframe() || Config.replay_scenario) {
        fn();
    } else {
        const checkInt = setInterval(() => {
            if (messageResizeGot) {
                fn();
                clearInterval(checkInt);
            }
        }, 50);
    }
}

export function startGame(sceneClass) {
    docReady(function() {
        awaitSizes(() => {
            const path = `/fg/v2/games/${Config.game_name.toLowerCase()}/`;

            if(Config.assets.preLoadFonts && Object.keys(Config.assets.preLoadFonts).length) {
                const lastFontName = Object.keys(Config.assets.preLoadFonts)[Object.keys(Config.assets.preLoadFonts).length-1];

                for (const [ name, fileName ] of Object.entries(Config.assets.preLoadFonts)) {
                    const isLast = name === lastFontName;
                    loadFont(name, `${path}${fileName}`, isLast ? loadPreloaderFont : function() {}, isLast ? sceneClass : false);
                }
            } else {
                loadPreloaderFont(sceneClass);
            }
        })
    });
}

function loadPreloaderFont(sceneClass) {
    syncFrameHeight(Config.windowHeight, neededWidth, game);
    loadFont("Artifakt", "/fonts/Artifakt_Element_Regular.ttf", () => {
        
        let prScene = game.scene.getScene('PreloadScene');
        prScene.events.on("ready", function () { 
            setTimeout(() => {
                if(loadStarted) {
                    return;
                }
                loadStarted = true;
                if(emergencyLoadTimer) {
                    clearTimeout(emergencyLoadTimer);
                }
        
                function setRelay() {
                    game.scene.add('GameScene', sceneClass);
        
                    scene = game.scene.getScene('GameScene');
        
                    if (scene.relay) {
                        store.commit('setRelayMethods', scene.relay.methods);
                        game.events.off(Phaser.Core.Events.POST_RENDER, setRelay);
                    }
        
                    syncFrameHeight(Config.windowHeight, neededWidth, game);
                    gameStarted = true;
                }
        
                game.events.on(Phaser.Core.Events.POST_RENDER, setRelay);
            }, 500);
        });

        prepareMultiLanguageAssets(() => {
            game.scene.start('PreloadScene');
        })
    });
}

function prepareMultiLanguageAssets(callback) {
    let filesToChange = [];
    for (const [ type, items ] of Object.entries(Config.assets)) {
        for (const [ name, fileName ] of Object.entries(items)) {
            if(!['images', 'spritesheets', 'atlas'].includes(type)) {
                continue;
            }
            let needReplace = fileName.search('--language--');

            if(needReplace !== -1) {
                let newFileName = fileName.replace('--language--', Config.language);

                filesToChange.push({type, name, newFileName});
            }
        }
    }

    if(filesToChange.length) {
        for (const [ index, item ] of Object.entries(filesToChange)) {
            loadAfterTransform(item, (parseInt(index) === filesToChange.length-1 ? callback : false));
        }
    } else {
        callback();
    }
}

function loadAfterTransform(item, callback) {
    let appendToLink = '';

    const path = `/fg/v2/games/${Config.game_name.toLowerCase()}/`;

    if (item.type === 'atlas') {
        appendToLink = '.png';
    }
    
    doesFileExist(path + item.newFileName + appendToLink)
        .then(
            () => {
                Config.assets[item.type][item.name] = item.newFileName; 

                if(callback) {
                    callback();
                }
            }, 
            () => {
                Config.assets[item.type][item.name] = Config.assets[item.type][item.name].replace('--language--', 'en');
                if(callback) {
                    callback();
                }
            }
        );
}

function doesFileExist(url) {
    return new Promise(function (resolve, reject) {
        let img = new Image();
        img.onerror = img.onabort = function () {
            reject();
        };
        img.onload = function () {
            resolve();
        };

        img.src = url;
    });
}

game.scene.add('PreloadScene', PreloadScene, false);